module.exports = __webpack_public_path__ + "static/media/allview.b37dc503.svg";